export default {
  EXCEPTIONS: "EXCEPTIONS",
  PREMIUMS: "PREMIUMS",
  OPPORTUNITY: "OPPORTUNITY",
  CONSOLIDATED: "CONSOLIDATED",
  MATCHING_POSTCODES: "MATCHING_POSTCODES",
  NON_COMPATIBLES: "NON_COMPATIBLES",
  NON_LOADED_PARCELS: "NON_LOADED_PARCELS",
  NON_CADS: "NON_CADS",
  SHOW_IN_ROUTE: "SHOW_IN_ROUTE",
};
